export const vergabeWissenFooterData = [
  {
    type: "FooterHeroColumn",
    title: "B_I MEDIEN",
    link: "",
    youtube: "https://www.youtube.com/channel/UCojRk_tvvwegr0hZRYIhX-w",
    paragraph:
      "Vergabeplattform für Öffentliche Ausschreibungen und private Bauaufträge.",
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Auftragnehmer: Aufträge finden",
    link: "/ausschreibungsdienste",
    paragraph:
      "Öffentliche Ausschreibungen und private Aufträge aus ganz Deutschland einfach und schnell finden.",
    column_items: [
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen",
        label: "Öffentliche Ausschreibungen",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen/private-und-gewerbliche-auftraege-finden",
        label: "Private Aufträge",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/teilnehmen",
        label: "An Vergaben teilnehmen",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Auftraggeber: Aufträge vergeben",
    link: "/evergabe",
    paragraph:
      "Elektronisches Vergabemanagementsystem für die Vergabe öffentlicher Aufträge aller Art.",
    column_items: [
      {
        type: "FooterLink",
        link: "/evergabe/produkt",
        label: "Elektronisches Vergabemanagement",
      },
      {
        type: "FooterLink",
        link: "/evergabe/wie-gelingt-die-erste-elektronische-vergabe",
        label: "Einführung in die eVergabe",
      },
    ],
  },
]
